import { render, staticRenderFns } from "./ElementAudio.vue?vue&type=template&id=881af568&"
import script from "./ElementAudio.vue?vue&type=script&lang=js&"
export * from "./ElementAudio.vue?vue&type=script&lang=js&"
import style0 from "./ElementAudio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports